import { render, staticRenderFns } from "./certificate-form.vue?vue&type=template&id=798059ce&scoped=true&"
import script from "./certificate-form.ts?vue&type=script&lang=ts&"
export * from "./certificate-form.ts?vue&type=script&lang=ts&"
import style0 from "./certificate-form.scss?vue&type=style&index=0&id=798059ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798059ce",
  null
  
)

export default component.exports